import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CompanyService } from '@features/company/services/company.service';
import { ConfigurationService } from '@features/configuration/services/configuration.service';
import { map } from 'rxjs';

/**
 * @description
 * Permite la ruta solo si el flujo de aprobación
 * (`configuration/maturities/manage-traceability`) está habilitado (`enabled === true`).
 * Si está deshabilitado, redirige a `data.redirectWhenDisabled` o `data.backFallback`.
 */
export const manageTraceabilityEnabledGuard: CanActivateFn = (route) => {
  const companyService = inject(CompanyService);
  const configurationService = inject(ConfigurationService);
  const router = inject(Router);

  const redirectTo =
    (route.data['redirectWhenDisabled'] as string | undefined) ??
    (route.data['backFallback'] as string | undefined) ??
    '/home';
  const redirectTree = router.parseUrl(redirectTo);

  const businessId = companyService.business?.id ?? companyService.businessId();
  if (!businessId) {
    return redirectTree;
  }

  return configurationService.ensureManageTraceabilityLoaded(businessId).pipe(
    map((config) => (config?.enabled ? true : redirectTree)),
  );
};
